import React from 'react'

export default function OrgNotFound() {
  return (
    <div style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ maxWidth: 520, textAlign: 'center' }}>
        <div style={{ fontSize: 48, fontWeight: 800, color: '#111827' }}>404</div>
        <div style={{ fontSize: 22, fontWeight: 700, color: '#1f2937', marginTop: 8 }}>Organization not found</div>
        <p style={{ color: '#6b7280', marginTop: 8 }}>
          This subdomain isn’t registered. If you’re trying to access your organization, please check the URL or contact your admin.
        </p>
        <a href="https://learn.astra-xr.com" style={{ display: 'inline-block', marginTop: 16, padding: '10px 16px', background: '#2563eb', color: 'white', borderRadius: 8 }}>Go to main site</a>
      </div>
    </div>
  )
}


